export default {
  ballStyle: {
    fill: '#777',
    stroke: '#444',
    strokeWidth: '2px',
  },
};



// WEBPACK FOOTER //
// ./src/components/CannonBall/styles.js